import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import BaseComponent from '../../../../baseClasses/BaseComponent'; 
import DataSource from '../../../../dao/DataSource/DataSource';
import './PORLocationChildCard.scss';

// TODO: reduce complexity in this component
class PORLocationChildCard extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { 
    };
  }
  
  handleLocationRetrieval(location, action, acData, fetchedData) {
    this.setState({ location });
  }

  componentDidMount() {
    super.componentDidMount(this);

    if (this.props.location && this.props.location.id >= 0) {
      this.locationDataSource = new DataSource('Location', this.props.location.id, { location: {} }, this.handleLocationRetrieval);
      this.locationDataSource.get();
    }
  }

  componentWillUnmount() {
    if (this.locationDataSource) {
      this.locationDataSource.release();
      this.locationDataSource = null;
    }
  }

  componentDidUpdate(prevProps) {
  }

  handleLocationSelection(select) {
    const { selectLocation, project } = this.props;
    const { location } = this.state;
    if (selectLocation) {
      selectLocation(location, project);
    }
  }

  handleEditLocation(e) {
    e.stopPropagation();
    if (this.props.editLocation) {
      this.props.history.saveCurrentLocation();
      this.props.editLocation(this.state.location);
    }
  }

  render() {
    let { selected, noLocations, permissions } = this.props;

    const canEdit = permissions.isSuperUser || permissions.canEditLocation;
    let { location } = this.state;
    if (noLocations) {
      return (
        <div
        id={this.props.id}
        className={'por-location-child-card'}
      >
        <div className='location-child-box'>
          <div className="location-child-icon-container">
            <div className="location-child-icon" />
          </div>
          <div className="location-child-info">
            <div className="location-child-name">
              {'There are no locations assigned to the projects'}
            </div>
          </div>
        </div>
      </div>);
    }
    else if (!location) {
      return null;
    }
    
    return (
      <div
        id={this.props.id}
        className={'por-location-child-card' + (selected ? ' selected' : '')}
        onClick={this.handleLocationSelection}
      >
        <div className='location-child-box'>
          <div className="location-child-icon-container">
            <div className="location-child-icon" />
          </div>
          <div className="location-child-info">
            <div className="location-child-name">
              {location.name}
            </div>
            <div className="location-child-id">
              {'ID: ' + location.guid}
            </div>
          </div>
          {canEdit ? <div className={'location-child-edit'} onClick={this.handleEditLocation} /> : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permissions: state.new_users.permissions,
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps)(PORLocationChildCard);



// WEBPACK FOOTER //
// ./src/containers/PORContainer/PORNav/PORLocationChildCard/index.js